import { AccountBadgeStatus } from '@juvare/badging/backend/features/badges/shared';
import { Alert } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';

interface BadgeAlertProps {
    accountBadgeStatus: AccountBadgeStatus;
    badgeTitle: string;
    badgeOrganization?: string;
}

export const BadgeAlert: React.FC<BadgeAlertProps> = ({ accountBadgeStatus, badgeTitle, badgeOrganization }) => {
    const { t } = useTranslation();

    const isBadgeValid = accountBadgeStatus === 'valid';

    return (
        <Alert severity={isBadgeValid ? 'success' : 'error'}>
            {t(`pages.home.checkInModal.messages.${accountBadgeStatus}${badgeOrganization ? '' : 'NoOrganization'}`, {
                badgeTitle,
                badgeOrganization,
            })}
        </Alert>
    );
};
